import { Observable } from "rxjs";
import { Injectable } from "@angular/core";

import { CoreService } from "./../../base/core";
import { ServiceRoute } from "../../base/service-route";
import { CommonHttpOption } from "./../../base/common-http-option";
import { IPlacementReservationAdd } from "src/app/interfaces/placementReservationAdd";
import { IPlacementReservationTime } from "src/app/interfaces/placementReservationTime";

@Injectable({
  providedIn: "root"
})
export class PlacementReservationService {
  constructor(private core: CoreService) {}

  placementReservationTime(data: IPlacementReservationTime): Observable<any> {
    return this.core.post(
      ServiceRoute.placementReservation.placementReservationTime,
      data,
      new CommonHttpOption().headers
    );
  }

  placementReservationAdd(data: IPlacementReservationAdd): Observable<any> {
    return this.core.post(
      ServiceRoute.placementReservation.reservationAdd,
      data,
      new CommonHttpOption().headers
    );
  }
}
